import config from "./config.json";

export const SERVER_DOMAIN_URL = process.env.REACT_APP_SERVER_BACKEND_URL;
export const SERVER_URL = `${process.env.REACT_APP_SERVER_BACKEND_URL}/api`;
export const SIGNUP_API_PATH = config.SIGNUP_API_PATH;
export const SIGNUP_VERIFICATION_API_PATH = config.SIGNUP_VERIFICATION_API_PATH;
export const LOGIN_API_PATH = config.LOGIN_API_PATH;
export const REFRESH_TOKEN_API_PATH = config.REFRESH_TOKEN_API_PATH;
export const FORGOT_PASSWORD_API_PATH = config.FORGOT_PASSWORD_API_PATH;
export const PASSWORD_RESET_API_PATH = config.PASSWORD_RESET_API_PATH;
export const DEVELOPER_API_PATH = config.DEVELOPER_API_PATH;
export const PAYMENT_PLAN_API_PATH = config.PAYMENT_PLAN_API_PATH;
export const AMENITY_API_PATH = config.AMENITY_API_PATH;
export const PROPERTY_API_PATH = config.PROPERTY_API_PATH;
export const CONTACT_US_API_PATH = config.CONTACT_US_API_PATH;
export const SUBSCRIBE_API_PATH = config.SUBSCRIBE_API_PATH;
export const BLOG_API_PATH = config.BLOG_API_PATH;
export const EVENT_REGISTRATION_API_PATH = config.EVENT_REGISTRATION_API_PATH;
export const AWS_ACCESS_KEY_ID = process.env.REACT_APP_AWS_ACCESS_KEY_ID;
export const AWS_SECRET_ACCESS_KEY = process.env.REACT_APP_AWS_SECRET_ACCESS_KEY;
export const AWS_REGION = process.env.REACT_APP_AWS_REGION;
export const AWS_S3 = process.env.REACT_APP_AWS_S3;
export const ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT;
export const AWS_S3_BUCKET =`${process.env.REACT_APP_AWS_S3}/${process.env.REACT_APP_ENVIRONMENT}`;
export const EVENT_POSTER_IMAGE_PREFIX = config.EVENT_POSTER_IMAGE_PREFIX;